import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import TextField from '../TextPlugin/TextField';
import createStore from '../../../../plugins/utils/createStore';
import { NumberIcon } from '../../../Icons';
import ColumnTypes from '../../types/ColumnTypes';
import OrderTypes from '../../types/OrderTypes';
import makeOnStartTyping from '../TextPlugin/makeOnStartTyping';
var NUMBER_EXTRACT = /([\d]+[.,]?[\d]*)/;
var NUMBER_FROM_TODO = /\s*checked\s*/i;

function convertTextToNumber(text) {
  if (NUMBER_FROM_TODO.test(text)) return '1';
  var matches = NUMBER_EXTRACT.exec(text) || [];

  if (!matches) {
    return '';
  }

  var number = parseFloat(matches[0]);
  return Number.isNaN(number) ? '' : number.toString();
}

export default function NumberPlugin() {
  var store = createStore();
  return [makeOnStartTyping([ColumnTypes.NUMBER], store), {
    renderColumnIcon: function renderColumnIcon(columnType, database, next) {
      if (columnType === ColumnTypes.NUMBER) {
        return React.createElement(NumberIcon, {
          size: 12
        });
      }

      return next();
    },
    renderColumnType: function renderColumnType(columnType, database, next) {
      if (columnType === ColumnTypes.NUMBER) {
        return 'Number';
      }

      return next();
    },
    canSort: function canSort(columnType, database, next) {
      if (columnType !== ColumnTypes.NUMBER) {
        return next();
      }

      return true;
    },
    getSortOptions: function getSortOptions(columnType, database, next) {
      var _ref;

      if (columnType !== ColumnTypes.NUMBER) {
        return next();
      }

      return _ref = {}, _defineProperty(_ref, OrderTypes.ASC, 'Lowest first'), _defineProperty(_ref, OrderTypes.DESC, 'Highest first'), _ref;
    },
    getSortStrategies: function getSortStrategies(columnType, database, next) {
      var _ref2;

      if (columnType !== ColumnTypes.NUMBER) {
        return next();
      }

      var orderBy = function orderBy(order) {
        return function (recordA, recordB, columnKey) {
          var textA = database.getFieldData(recordA.key, columnKey).text || '';
          var textB = database.getFieldData(recordB.key, columnKey).text || '';
          textA = +textA;
          textB = +textB;
          var aLowerThanB = textA - textB;
          return aLowerThanB * (order === OrderTypes.ASC ? 1 : -1);
        };
      };

      return _ref2 = {}, _defineProperty(_ref2, OrderTypes.ASC, orderBy(OrderTypes.ASC)), _defineProperty(_ref2, OrderTypes.DESC, orderBy(OrderTypes.DESC)), _ref2;
    },
    renderField: function renderField(_ref3, database, next) {
      var column = _ref3.column,
          field = _ref3.field,
          record = _ref3.record,
          isFocused = _ref3.isFocused;

      if (column.type !== ColumnTypes.NUMBER) {
        return next();
      }

      var fieldKey = database.getFieldKey(record.key, column.key);
      var storeItem = store.getItem(fieldKey);
      var value = storeItem ? storeItem.initialValue : field.data.text || '';
      return React.createElement(TextField, {
        className: "text-align-right",
        database: database,
        value: value,
        recordKey: record.key,
        columnKey: column.key,
        isFocused: isFocused,
        store: store,
        format: convertTextToNumber
      });
    },
    convertField: function convertField(source, destination, database, next) {
      if (ColumnTypes.NUMBER !== destination.column.type) return next();
      var text = typeof source === 'string' ? source : database.run('serializeField', source);
      return {
        text: convertTextToNumber(text) || text === 'checked' && '1' || '0'
      };
    },
    serializeField: function serializeField(_ref4, database, next) {
      var field = _ref4.field,
          record = _ref4.record,
          column = _ref4.column;
      if (ColumnTypes.NUMBER !== column.type) return next();
      return field.data.text;
    }
  }];
}